export default "__VITE_ASSET__ce6fbff3__"